import { Button } from "@omni/ui/components/Button/button.component";
import { useState } from "react";

import { Modal } from "@/components/General/Modal/modal";
import { Table } from "@/components/General/Table/table.component";
import { TBody } from "@/components/General/Table/tbody.component";
import { Td } from "@/components/General/Table/td.component";
import { Tr } from "@/components/General/Table/tr.component";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";
import { ArticleConfiguration } from "@/types/service/cart/shared";

export type ProductConfigurationDetailComponentProps = {
    configuration?: ArticleConfiguration | null;
};

type DetailProps = {
    configuration: ArticleConfiguration;
};

const Details = ({ configuration }: DetailProps) => {
    const { t } = useGranite();

    return (
        <div>
            <div className="h3 text-secondary-link-color">
                {t("product.configuration.detail.modal.subtitle")}
            </div>
            <Table>
                <TBody>
                    {configuration?.materials.map((keyValue) => (
                        <Tr
                            striped={true}
                            key={keyValue.code}
                        >
                            <Td>{keyValue.code}</Td>
                            <Td>{keyValue.value}</Td>
                        </Tr>
                    ))}
                </TBody>
            </Table>
        </div>
    );
};

export const ProductConfigurationDetailComponent = ({
    configuration
}: ProductConfigurationDetailComponentProps) => {
    const { t } = useGranite();
    const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

    if (!configuration?.materials) {
        return null;
    }

    return (
        <>
            <Button
                type="button"
                color="link"
                className={"pl-0"}
                onClick={() => setIsModalOpen(!isModalOpen)}
            >
                {t("product.configuration.detail.button")}
            </Button>
            <Modal
                title={t("product.configuration.detail.modal.title")}
                open={isModalOpen}
                closable={true}
                cancelButtonText={t("general.alert.close")}
                setOpen={setIsModalOpen}
            >
                <Details configuration={configuration} />
            </Modal>
        </>
    );
};
